<template>
	<div>
		<sidebar scroll-to-speed="750"/>
		<title-section scroll-to-speed="750"/>
		<experiences-section/>
		<footer-section/>
		<!-- <projects-section/> -->
	</div>
</template>

<script>
	import Sidebar from '../sidebar/sidebar'
	import TitleSection from '../landingPage/titleSection'
	import ExperiencesSection from '../landingPage/experiencesSection'
	import FooterSection from '../landingPage/footerSection'
	//import ProjectsSection from '../landingPage/projectsSection'
	export default {
		name: "LandingPage",
		components: {
			Sidebar,
			TitleSection,
			ExperiencesSection,
			FooterSection,
			//ProjectsSection,
		}
	}
</script>

<style lang="scss">
	@import "../../styles/global.scss";
	@import "../../styles/text_mixins.scss";
	@import "../../styles/transition_mixins.scss";
	@import "../../styles/position_mixins.scss";
	@import "../../styles/dimension_mixins.scss";
	@import "../../styles/background_mixins.scss";

	.scrollto_next {
		@include text(
			$color: $light_contrast,
			$decoration: none
		);
		@include background(
			$color: $most_transparent_black,
			$border-radius: 50%
		);
		margin-bottom: 32px;
		outline: 0;
		@include dimensions( 75px, 75px );
		@include position( flex, absolute, $bottom: 0px );
		@include content_position( center, center );
		@include transition( 0.2s ease );
		&:hover {
			color: $accent;
			background-color: $less_transparent_black;
			margin-bottom: 22px;
			@include transition( 0.1s ease );
		}
	}
	.section {
		margin-left: 50px;
		display: flex;
		justify-content: center;
		& .section_content {
			width: 66%;
		}
	}
	@media (max-width: 1024px) {
		.scrollto_next {
			right: 0px;
			margin-right: 32px;
		}
		.section {
			& .section_content {
				width: 80%;
			}
		}
	}
	@media (max-width: 500px) {
		.sidebar {
			visibility: hidden;
		}
		.section {
			margin-left: 0px;
			justify-content: center;
			& .section_content {
				width: 100%;
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/landingPage/index.vue